import { stringify, ParsedUrlQuery } from 'querystring';

import { SearchQueryParams } from '../types/SearchQuery';
import filterParams from '../../common/utils/filterParams';

const API_CATEGORY_SEO_ROUTE = '/api/v4/rutter/v1/search/seo/category/?';

type CategorySeoQueryParams = Pick<SearchQueryParams, 'category_slug'>;

const ALLOWED_PARAMS: (keyof CategorySeoQueryParams)[] = [
  'category_slug',
];

/**
 * Returns the category seo url for the specified query.
 * Unrecognized params will be removed.
 * The params are ordered alphabetically.
 */
const getCategorySeoUrl = (
  query: ParsedUrlQuery,
): string => API_CATEGORY_SEO_ROUTE + stringify(
  filterParams<CategorySeoQueryParams>({
    query,
    allowedParams: ALLOWED_PARAMS,
    defaultParams: { category_slug: 'boat-rental' },
  }),
);

export default getCategorySeoUrl;
